export function initGlowWrapper() {
    const glowWrapper = document.querySelector(".glow-wrapper");
 
    // Exit if .glow-wrapper doesn't exist
    if (!glowWrapper) return;
 
    glowWrapper.classList.add("is-visible");
}